//# sourceMappingURL=my-default-month.interface.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/mydatepicker/dist/interfaces/my-default-month.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-default-month.interface.js
// module chunks = 4